const Data: string[] = [
    "MBCL", 
    "BBAC", 
    "FBAC"
];
export default Data;
